import { PropsWithChildren } from "react";
import styles from "./button.module.css";

interface ComponentProp extends PropsWithChildren {
  variant: string;
  width?: string;
  onClick?: () => void;
  underline?: boolean;
  color?: string;
  fontSize?: string;
  bordered?: boolean;
  borderBottom?: string;
  disabled?: boolean;
  type?: "submit" | "reset" | "button" | undefined;
}

const CustomButton: React.FC<ComponentProp> = ({
  children,
  variant,
  onClick,
  underline,
  color,
  width,
  fontSize,
  bordered,
  disabled,
  type,
  borderBottom,
}) => {
  const buttonVariants = [
    "solid",
    "primary",
    "ghost",
    "outline",
    "transparent",
    "naked",
    "default",
  ];

  return (
    <>
      {variant === buttonVariants[0] && (
        <button
          className={styles.solid}
          onClick={onClick}
          style={{ width: width ? width : "100%", fontSize: fontSize }}
          disabled={disabled}
          type={type}
        >
          {children}
        </button>
      )}

      {variant === buttonVariants[1] && (
        <button
          className={styles.primary}
          onClick={onClick}
          style={{ width: width ? width : "100%", fontSize: fontSize }}
          disabled={disabled}
          type={type}
        >
          {children}
        </button>
      )}

      {variant === buttonVariants[2] && (
        <button
          className={styles.ghost}
          onClick={onClick}
          disabled={disabled}
          type={type}
        >
          {children}
        </button>
      )}

      {variant === buttonVariants[3] && (
        <button
          className={styles.outline}
          onClick={onClick}
          style={{ width: width ? width : "100%", fontSize: fontSize }}
          disabled={disabled}
          type={type}
        >
          {children}
        </button>
      )}

      {variant === buttonVariants[4] && (
        <button
          className={styles.transparent}
          onClick={onClick}
          style={{ border: bordered ? "1px solid E5E6E6" : "none", borderBottom: borderBottom, color: color }}
          disabled={disabled}
          type={type}
        >
          {children}
        </button>
      )}

      {variant === buttonVariants[5] && (
        <button
          className={styles.naked}
          style={{
            textDecoration: underline ? "underline" : "none",
            color: color ? color : "#5BC065",
          }}
          onClick={onClick}
          disabled={disabled}
          type={type}
        >
          {children}
        </button>
      )}

      {variant === buttonVariants[6] && (
        <button
          className={styles.default}
          style={{ width: width ? width : "100%", fontSize: fontSize }}
          disabled={disabled}
          type={type}
          onClick={onClick}
        >
          {children}
        </button>
      )}

      {/* {(variant === buttonVariants[5]) && <button className={styles.naked} style={{textDecoration : underline ? "underline" : "none", color: color ? color: "#5BC065"}} onClick={onClick}>{text}</button>} */}
    </>
  );
};

export default CustomButton;
